export default __webpack_public_path__ + "static/media/prize_round.bf54ff6f.mp3";